{
  "header": "资产详情",
  "subtitle": "挂接在您卡车上的资产（拖车、集装箱等）。",
  "assetType": "资产类型",
  "assetTypePlaceholder": "选择资产类型",
  "assetId": "资产编号（例如拖车编号）",
  "assetIdPlaceholder": "例如：拖车编号、集装箱编号等",
  "remove": "移除",
  "addAnother": "添加另一项资产",
  "trailerType": "拖车类型",
  "trailerId": "拖车编号"
}
